import axios from 'axios';
import { setError } from './globalActions';
import Api from '../Config';

export const getAmbassadors = ambassadors => ({
  type: 'GET_AMBASSADORS',
  ambassadors,
});
export const getAmbassador = activeAmbassador => ({
  type: 'GET_AMBASSADOR',
  ...activeAmbassador,
});

export const fetchAmbassadors = lang => (dispatch) => {
  axios.get(`${Api.base + lang}/${Api.ambassadors}`).then((response) => {
    const data = response.data;
    dispatch(getAmbassadors(data));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};


export const fetchAmbassador = (lang, options) => (dispatch) => {
  axios.get(`${Api.base + lang}/${Api.ambassador}`, { params: { ...options } }).then((response) => {
    const data = response.data;
    dispatch(getAmbassador(data));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/ambassadorsActions.jsx